import type { FeatureToggle } from 'shared/settings/CarrierSettingsAPI';

export const ADDRESS_VERIFICATION_FEATURE: FeatureToggle =
  'ctms_loads_address_verification';
